import { cn } from "@/lib/utils";

/** Full TeachersHub wordmark. Sidebar/nav/footer scale to their container (width- or height-bounded) so narrow layouts do not clip the wordmark. */
export function BrandLogo({
  variant,
  className,
}: {
  variant: "sidebar" | "nav" | "footer";
  className?: string;
}) {
  const presets = {
    sidebar: {
      frame:
        "w-full min-w-0 h-20 flex items-center justify-start overflow-visible rounded-sm",
      img: "w-full h-auto max-h-20 object-contain object-left",
      imgLayout: "min-w-0" as const,
    },
    nav: {
      frame:
        "w-full min-w-0 flex-1 h-20 flex items-center justify-start overflow-visible",
      img: "h-20 w-auto max-w-full min-w-0 object-contain object-left origin-left",
      imgLayout: "min-w-0" as const,
    },
    footer: {
      frame:
        "min-w-0 max-w-full h-12 flex items-center justify-start overflow-visible",
      img: "h-12 w-auto max-w-full min-w-0 object-contain object-left origin-left opacity-90",
      imgLayout: "min-w-0" as const,
    },
  }[variant];

  return (
    <div className={cn(presets.frame, className)}>
      <img
        src="/logo_full.png"
        alt="TeachersHub"
        width={400}
        height={80}
        className={cn("block", presets.imgLayout, presets.img)}
        data-testid={variant === "nav" ? "text-app-name" : undefined}
      />
    </div>
  );
}
